import React, { Fragment, KeyboardEventHandler } from "react";
import clsx from "clsx";
import NominationHeader from "../common/NominationHeader";
import moment from "moment";
import queryString from "query-string";
import {
  EmailWorkPacketsRequest,
  OtherOption,
} from "../../models/EmailWorkPacketsRequest";
import { Checkbox, Text } from "@fluentui/react";
import { connect } from "react-redux";
import { emailApi } from "../../api/emailApi";
import { FC } from "react";
import { GeneralService } from "../../services/GeneralService";
import { last6Digits, toNominationNo } from "../../services/Helper";
import { Link, useParams } from "react-router-dom";
import {
  Dropdown,
  DropdownMenuItemType,
  IDropdownOption,
  IDropdownStyles,
  mergeStyles,
} from "office-ui-fabric-react";
import { mergeStyleSets } from "@fluentui/react";
import { State } from "../../store";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useState } from "react";
import { WorkPacketExt } from "../../models/WorkPacket";
import * as ActivityLogStore from "../../store/ActivityLogsStore";
import * as LineHandlingStore from "../../store/LineHandlingStore";
import * as WorkPacketStore from "../../store/WorkPacketStore";
import * as GeneralStore from "../../store/GeneralStore";
import {
  loadPdfDoc,
  mergedPdfs,
  mergedPdfsAsBytes,
} from "../../services/PdfDocumentService";
import Modal from "../common/Modal";
import Email from "../common/Email";
import CreatableSelect from "react-select/creatable";
import * as SofViewStore from "../../store/SofViewStore";
import { SofView } from "../../models/SofView";
import { FontIcon } from "office-ui-fabric-react/lib/Icon";
import { DailyReportNomination } from "../../models/DailyReportNomination";
import { Nomination } from "../../models";
import * as TruckNominationStore from "../../store/TruckNominationStore";
import TruckNominationHeader from "../truck/TruckNominationHeader";
import SofIcon from "../common/Icons";
import AttachmentModal from "../truck/AttachmentModal";

interface Option {
  readonly label: string;
  readonly value: string;
}

type IProps = ActivityLogStore.ActivityLogsState &
  WorkPacketStore.WorkPacketState &
  LineHandlingStore.LineHandlingState &
  TruckNominationStore.TruckNominationState &
  SofViewStore.SofViewState &
  GeneralStore.GeneralState &
  typeof WorkPacketStore.actionCreators &
  typeof GeneralStore.actionCreators &
  typeof LineHandlingStore.actionCreators &
  typeof TruckNominationStore.actionCreators &
  typeof SofViewStore.actionCreators;

const panelRow = mergeStyles({
  display: "flex",
});
const headerTitle = mergeStyles({
  letterSpacing: "0.004em",
});

const classes = mergeStyleSets({
  packetList: {
    overflowX: "hidden",
    overflowY: "scroll",
    maxHeight: "calc(100vh - 250px)",
    padding: "0",
    marginRight: "1px",
  },
  detailsDiv: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    "-webkit-line-clamp": "1",
    display: "-webkit-box",
    "-webkit-box-orient": "vertical",
  },
  viewButton: {
    width: "40px",
    height: "40px",
    borderRadius: "5px",
    border: "1px solid #E2E6E8",
    backgroundColor: "#FAFAFA",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    selectors: {
      ":hover": {
        backgroundColor: "#EEEEEE",
        textDecoration: "none",
      },
    },
  },
  addNew: {
    // width: "148px",
    height: "40px",
    paddingLeft: "24px",
    paddingRight: "24px",
    border: "1px solid var(--primary-500)",
    backgroundColor: "var(--primary-500)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    borderRadius: 4,
    selectors: {
      ":hover": {
        backgroundColor: "#F3F6F7",
        color: "#000",
        textDecoration: "none",
        border: "1px solid #F3F6F7",
      },
      ":active": {
        backgroundColor: "#F3F6F7",
        color: "#000",
        textDecoration: "none",
        border: "1px solid #F3F6F7",
      },
      ":focus": {
        backgroundColor: "#F3F6F7",
        color: "#000",
        textDecoration: "none",
        border: "1px solid #F3F6F7",
        outline: "none",
      },
    },
    color: "white",
  },
  flexEnd: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
  },
  dotIndicator: {
    width: "12px",
    height: "12px",
    borderRadius: "8px",
    marginRight: "5px",
    marginTop: "2px",
  },
  formFooter: {
    position: "absolute",
    bottom: 15,
    padding: 16,
    backgroundColor: "white",
    alignItems: "center",
  },
  formFooterInner: {
    maxWidth: 900,
    margin: "auto",
    // display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  sendButton: {
    padding: "8px 36px",
    backgroundColor: "#009FDF",
    color: "#F6F6F6",
    border: "none",
    borderRadius: 2,
  },
  sentButton: {
    padding: "8px 36px",
    backgroundColor: "#008000",
    color: "#F6F6F6",
    border: "none",
    borderRadius: 2,
  },
  errorButton: {
    padding: "8px 36px",
    backgroundColor: "red",
    color: "#F6F6F6",
    border: "none",
    borderRadius: 2,
  },
  formHeader: {
    gap: 8,
    padding: "0px 16px 16px 16px",
    display: "flex",
    alignItems: "center",
    backgroundColor: "white",
  },
  formHeaderTitle: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: "24px",
    letterSpacing: "0.005em",
    color: "#4C4C4C",
  },
  toolbarSeparator: {
    height: "40px",
    width: "1px",
    background: "#D8DFE6",
    margin: "0",
  },
  inputBox: {
    border: "1px solid #D8DFE6",
    width: "100%",
  },
  modalEmail: {
    width: "100%",
    height: "100%",
    border: "0",
    boxShadow: "0 0 1em rgb(0 0 0 /.3)",
  },
  modalContainer: {
    display: "flex",
    height: "91vh",
  },
  modalPdfPreviewContainer: {
    flex: 1,
  },
  modalRightPanelContainer: {
    width: "25%",
  },
  modalComponent: {
    paddingRight: 16,
    paddingLeft: 16,
  },
  modalSelectedItemWrapper: {
    paddingTop: 16,
    display: "flex",
    flexDirection: "column",
  },
  modalSelectedItem: {
    paddingLeft: 10,
  },
  headerRow: [
    panelRow,
    {
      alignItems: "center",
      padding: "6px 24px",
      background: "white",
      borderBottom: "1px solid #E2E6E8",
    },
  ],
  headerRowTextPane: [
    panelRow,
    {
      flexDirection: "column",
      flexGrow: 1,
      margin: "0 10px",
      paddingLeft: 10,
      borderLeft: "1px solid #E2E6E8",
    },
  ],
  headerTitle: [
    headerTitle,
    {
      fontSize: 16,
      lineHeight: "20px",
      fontWeight: "bold",
    },
  ],
});

const buttonIcon = mergeStyles({
  padding: "9px 10px",
  fontSize: 16,
  fontWeight: 500,
  height: 40,
  width: 40,
  justifyContent: "center",
  border: "1px solid #D8DFE6",
  borderRadius: "2px",
  display: "flex",
  alignItems: "center",
  color: "#4c4c4c",
  selectors: {
    [":active"]: {
      backgroundColor: "#008cc0",
    },
  },
});

const dropdownStyles: Partial<IDropdownStyles> = {
  root: { width: "40%" },
  dropdown: { width: "100%", height: "40px" },
  dropdownItemSelected: {
    selectors: {
      ":focus, :hover": { outline: "0 !important" },
    },
  },
  title: { height: "40px", lineHeight: "40px" },
  caretDownWrapper: { height: "40px", lineHeight: "40px" },
  dropdownItem: {
    selectors: {
      ":focus, :hover": { outline: "0 !important" },
    },
  },
  dropdownItemsWrapper: { overflow: "hidden" },
};

type MODALITY = "MARINE" | "TRUCK" | "RAIL";
export const ServicesList: FC<IProps> = (props: IProps) => {
  const { lineHandling, truckNomination } = props;
  const [selectedNominationNo, setSelectedNominationNo] = useState<string>("0");
  const [selectedNomination, setSelectedNomination] = useState<Nomination>();
  const { lineHandlingNo } = useParams() as any;
  const [selectedItems, setSelectedItems] = useState<any>([]);
  const [workPackets, setWorkPackets] = useState<WorkPacketExt[]>([]);
  const [unfilteredWorkPackets, setUnfilteredWorkPackets] = useState<
    WorkPacketExt[]
  >([]);

  const [nominationNo, setNominationNo] = useState<string>();
  const [pdfContent, setPdfContent] = useState<string>();
  const [inputValue, setInputValue] = useState<string>("");
  const [emailAddresses, setEmailAddresses] = useState<readonly Option[]>([]);
  const [emailStatus, setEmailStatus] = useState<string>("default");
  const [emailErrorMessage, setEmailErrorMessage] = useState<string>();
  const [isLoaded, setIsLoaded] = useState<boolean>();
  const [pdfContentBlob, setPdfContentBlob] = useState<Blob>();
  const history = useHistory();
  const [readonly, setReadonly] = useState(false);
  const [modality, setModality] = useState<MODALITY>("MARINE");

  const modalities = {
    MARINE: 0,
    TRUCK: 1,
    RAIL: 2,
  };

  const getOptions = () => {
    const options: IDropdownOption[] = [];
    options.push({
      key: "All",
      text: `All`,
      selected: true,
    });
    options.push({
      key: "0",
      text: `Additional Services`,
    });

    lineHandling &&
      lineHandling.result &&
      lineHandling.result.nominations.map((nomination: any) => {
        options.push({
          key: nomination.nominationNo,
          text: `Nomination # ${nomination.nominationNo.substr(
            nomination.nominationNo.length - 5
          )}`,
          title: `${nomination.product}`,
        });

        return options;
      });

    return options;
  };

  //const colorEnum = ["#1890FF", "#4CAF50", "#00447E"];
  const colorEnum = ["var(--primary-500)", "var(--feedback-green)", "#00447E"];
  const handleSelectAll = (value?: boolean) => {
    if (value) {
      setSelectedItems(workPackets);
    } else {
      setSelectedItems([]);
    }
  };

  const createOption = (label: string) => ({
    label,
    value: label,
  });

  const components = {
    DropdownIndicator: null,
  };

  const getStatusByValue = (status: number) => {
    if (status === 0) {
      return "Pending";
    } else if (status === 1) {
      return "In progress";
    } else {
      return "Completed";
    }
  };

  const handleKeyDown: KeyboardEventHandler = (event) => {
    if (!inputValue) return;
    switch (event.key) {
      case "Enter":
      case "Tab":
        if (!validateEmail(inputValue)) {
          setEmailErrorMessage("Invalid email address.");
          return;
        }
        setEmailAddresses((prev) => [...prev, createOption(inputValue)]);
        setInputValue("");
        setEmailErrorMessage("");
        event.preventDefault();
    }
  };

  const handleCheckboxChange = (item: any, value?: boolean) => {
    if (value) {
      setSelectedItems((prevCheckboxes: any) => [...prevCheckboxes, item]);
    } else {
      setSelectedItems((prevCheckboxes: any) =>
        prevCheckboxes.filter((items: any) => items.key !== item.key)
      );
    }
  };

  useEffect(() => {
    const { search } = history.location;
    const q = queryString.parse(search.toLowerCase());
    const nominationno = q.nomination as string | undefined;

    if (history.location.pathname.indexOf("truck") > 0) {
      setModality("TRUCK");
      props.setPageTitle("Truck Nomination");
      props.setSofView(SofView.WorkPacket);
    } else if (history.location.pathname.indexOf("rail") > 0) {
      setModality("RAIL");
    } else {
      setModality("MARINE");
      if (!props.lineHandling.result) {
        props.getLineHandling(
          lineHandlingNo,
          nominationno,
          false,
          false,
          () => {}
        );
      }
    }
  }, []);

  useEffect(() => {
    setReadonly(
      // props?.lineHandling?.result?.status === 2 ||
        props?.lineHandling?.result?.status === 4 ||
        // props.truckNomination?.result?.status === 2 ||
        props.truckNomination?.result?.status === 4
    );
  }, [props.lineHandling, props.truckNomination]);

  useEffect(() => {
    if (props.workPackets.result && props.workPacketDocuments.result) {
      const wpService = new GeneralService(
        props.lineHandling.result,
        modality === "MARINE" ? undefined : props.truckNomination.result,
        props.activityLogs.result,
        props.workPacketValues.result
      );
      let _list = [];
      let counter = 0;
      for (const wp of props.workPackets.result) {
        if (wp.workPacketType > 1)
          if (wp.level === 1) {
            if (modality === "MARINE") {
              wpService.setActiveNomination();
            }
            const conditionsResult = wpService.checkConditions(wp.conditions);
            if (conditionsResult) {
              if (wp.workPacketType === 2) {
                const wpDoc = props.workPacketDocuments.result.find(
                  (f) => f.workPacketId === wp.id
                );
                _list.push({
                  ...wp,
                  key: `${counter}`,
                  displayName: wpDoc?.name ?? wp.name,
                  link:
                    modality === "TRUCK" || modality === "RAIL"
                      ? `/${modality.toLocaleLowerCase()}/${lineHandlingNo}/work-packet/${
                          wp.id
                        }`
                      : `/marine/${lineHandlingNo}/work-packet/${wp.id}`,
                  nominationNo: wp.nominationNo,
                } as WorkPacketExt);
              } else if (wp.workPacketType === 3) {
                const docs = props.workPacketDocuments.result.filter(
                  (f) => f.workPacketId === wp.id
                );
                for (const wpDoc of docs) {
                  _list.push({
                    ...wp,
                    key: `${counter}`,
                    documentId: wpDoc.id,
                    displayName: wpDoc.name,
                    nominationNo: wp.nominationNo,
                    link:
                      modality === "TRUCK" || modality === "RAIL"
                        ? `/${modality.toLocaleLowerCase()}/${lineHandlingNo}/work-packet/${
                            wp.id
                          }?documentId=${wpDoc.id}`
                        : `/marine/${lineHandlingNo}/work-packet/${wp.id}?documentId=${wpDoc.id}`,
                  } as WorkPacketExt);
                  counter++;
                }
              }
            }
          } else if (wp.level === 2 && props.lineHandling.result) {
            if (wp.workPacketType === 2) {
              let nominationsLoop =
                modality === "TRUCK" || modality === "RAIL"
                  ? [props.truckNomination.result]
                  : props.lineHandling.result.nominations;
              for (const nom of nominationsLoop) {
                const wpDoc = props.workPacketDocuments.result.find(
                  (f) =>
                    f.workPacketId === wp.id &&
                    f.nominationNo?.toUpperCase() ===
                      nom?.nominationNo?.toUpperCase()
                );
                wpService.setActiveNomination(nom?.nominationNo);
                const conditionsResult = wpService.checkConditions(
                  wp.conditions
                );
                if (conditionsResult) {
                  _list.push({
                    ...wp,
                    key: `${counter}-${nom?.nominationNo}`,
                    displayName: `${wp.name} - (${nom?.product} - ${last6Digits(
                      nom?.nominationNo
                    )})`,
                    nominationNo: nom?.nominationNo,
                    status: wpDoc ? wpDoc.status : 0,
                    link:
                      modality === "TRUCK" || modality === "RAIL"
                        ? `/${modality.toLocaleLowerCase()}/${lineHandlingNo}/work-packet/${
                            wp.id
                          }`
                        : `/marine/${lineHandlingNo}/work-packet/${wp.id}?nomination=${nom?.nominationNo}`,
                  } as WorkPacketExt);
                }
              }
            } else if (wp.workPacketType === 3) {
              const conditionsResult = wpService.checkConditions(wp.conditions);
              if (conditionsResult) {
                const docs = props.workPacketDocuments.result.filter(
                  (f) => f.workPacketId === wp.id
                );
                for (const wpDoc of docs) {
                  _list.push({
                    ...wp,
                    key: `${counter}`,
                    documentId: wpDoc.id,
                    displayName: wpDoc.name,
                    nominationNo: wpDoc.nominationNo,
                    link:
                      modality === "TRUCK" || modality === "RAIL"
                        ? `/${modality.toLocaleLowerCase()}/${lineHandlingNo}/work-packet/${
                            wp.id
                          }`
                        : `/marine/${lineHandlingNo}/work-packet/${wp.id}?documentId=${wpDoc.id}&nomination=${wpDoc.nominationNo}`,
                  } as WorkPacketExt);
                  counter++;
                }
              }
            }
          }
        counter++;
      }
      setUnfilteredWorkPackets(_list);
      setWorkPackets(_list);
    }
  }, [props.workPackets, props.workPacketDocuments]);

  useEffect(() => {
    props.setSofView(SofView.WorkPacket);
    const { search } = history.location;
    const q = queryString.parse(search.toLowerCase());
    const nominationno = q.nomination as string | undefined;

    setNominationNo(nominationno);
    props.getWPValues(lineHandlingNo);

    if (props.workPackets.result && props.workPackets.result.length === 0) {
      props.getAllWorkPackets();
    }
    props.setSofView(SofView.AdditionalServices);
  }, []);

  const validateEmail = (email: string) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const blobToBase64 = (blob: any) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    return new Promise((resolve) => {
      reader.onloadend = () => {
        resolve(reader.result);
      };
    });
  };

  const sendEmailModal = async () => {
    setEmailAddresses([]);
    setEmailStatus("default");
    setPdfContent("");
    setIsLoaded(false);
    const modal = document.getElementById(
      "sendemail-modal"
    ) as HTMLDialogElement;
    modal.showModal();

    let pdfs = [];

    for (var selectedItem of selectedItems) {
      const pdfDoc = await loadPdfDoc(
        selectedItem.layouts[0].pdfFile,
        lineHandlingNo,
        selectedItem.nominationNo,
        selectedItem.documentId,
        props.lineHandling,
        props.workPacketValues
      );
      if (pdfDoc) {
        const pdfUri = await pdfDoc.saveAsBase64({ dataUri: true });

        pdfs.push(pdfUri);
      }
    }

    const contents = await mergedPdfsAsBytes(pdfs);

    const blob = new Blob([contents], { type: "application/pdf" });
    setPdfContentBlob(blob);
    const docUrl = URL.createObjectURL(blob);
    setPdfContent(docUrl);
    setIsLoaded(true);
  };

  const closeEmailModal = () => {
    const modal = document.getElementById(
      "sendemail-modal"
    ) as HTMLDialogElement;
    modal.close();
  };

  const sendEmail = async () => {
    if (selectedItems.length === 0) return;

    if (pdfContent === undefined) return;

    setEmailStatus("sending");

    const result = (await blobToBase64(pdfContentBlob)) as string;

    const array = result?.split(",");
    const base64 = array.length > 0 ? array[1] : "";

    const workPackets = selectedItems.map(
      (a: { displayName: string }) => a.displayName
    );

    const currentDate = moment().format("YYYYMMDD-HHmm");

    let otherOptions: OtherOption[] = [];

    if (modality === "TRUCK" || modality === "RAIL") {
      otherOptions = [{ key: "nominationNo", value: lineHandlingNo }];
    }

    const attachmentRequest = {
      recipients: emailAddresses.map((a: { value: string }) => a.value),
      vesselName: props.lineHandling.result?.vesselName,
      attachments: [
        {
          content: base64,
          fileName: `workpackets-${currentDate}.pdf`,
          mimeType: "application/pdf",
        },
      ],
      workpackets: workPackets,
      status: props.lineHandling.result?.status,
      modality: modalities[modality],
      otherOptions: otherOptions,
    } as EmailWorkPacketsRequest;

    const emailResponse = await emailApi.sendEmailWorkPacketsAsync(
      attachmentRequest
    );

    if (emailResponse.emailStatus) {
      setEmailStatus("success");

      setTimeout(function () {
        const modal = document.getElementById(
          "sendemail-modal"
        ) as HTMLDialogElement;
        modal.close();
      }, 3000);
    } else {
      setEmailStatus("error");
    }
  };

  const closePrintPreviewModal = () => {
    const modal = document.getElementById(
      "print-preview-modal"
    ) as HTMLDialogElement;
    modal.close();
  };

  const printPreview = async () => {
    if (selectedItems.length === 0) return;

    const modal = document.getElementById(
      "print-preview-modal"
    ) as HTMLDialogElement;
    modal.showModal();

    setIsLoaded(false);

    let pdfs = [];

    for (var selectedItem of selectedItems) {
      const pdfDoc = await loadPdfDoc(
        selectedItem.layouts[0].pdfFile,
        lineHandlingNo,
        selectedItem.nominationNo,
        selectedItem.documentId,
        props.lineHandling,
        props.workPacketValues
      );
      if (pdfDoc) {
        const pdfUri = await pdfDoc.saveAsBase64({ dataUri: true });
        pdfs.push(pdfUri);
      }
    }
    const contents = await mergedPdfsAsBytes(pdfs);

    const blob = new Blob([contents], { type: "application/pdf" });
    const docUrl = URL.createObjectURL(blob);
    setPdfContent(docUrl);
    setIsLoaded(true);
  };

  const printDoc = () => {
    var iframe = document.getElementById("print-window") as HTMLIFrameElement;
    if (iframe && iframe.contentWindow) {
      iframe.focus();
      iframe.contentWindow.print();
    }
  };

  const download = async () => {
    if (selectedItems.length === 0) return;
    let pdfs = [];

    for (var selectedItem of selectedItems) {
      const pdfDoc = await loadPdfDoc(
        selectedItem.layouts[0].pdfFile,
        lineHandlingNo,
        selectedItem.nominationNo,
        selectedItem.documentId,
        props.lineHandling,
        props.workPacketValues
      );
      if (pdfDoc) {
        const pdfUri = await pdfDoc.saveAsBase64({ dataUri: true });
        pdfs.push(pdfUri);
      }
    }
    const contents = await mergedPdfs(pdfs);
    const currentDate = moment().format("YYYYMMDD-HHmm");
    let link = document.createElement("a") as HTMLAnchorElement;
    link.href = contents;
    link.download = `workpackets-${currentDate}.pdf`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    // props.setPageTitle("Marine Nominations");
  }, []);

  const getKeyByValue = (object: any, value: Number, nominationNo: string) => {
    return object.filter(
      (obj: any) =>
        obj.workPacketId === value && obj.nominationNo === nominationNo
    )[0];
  };

  return (
    <div>
      {modality === "TRUCK" || modality === "RAIL" ? (
        <Fragment>
          <div className="WorkPacketListWrapper">
            <div className={classes.headerRow}>
              <Fragment>
                {truckNomination.result?.transferType === "Tank to Truck" ||
                truckNomination.result?.transferType === "Tank to Rail Car" ? (
                  <Fragment>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="arrow_back">
                        <mask
                          id="mask0_6_1855"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="24"
                          height="24"
                        >
                          <rect
                            id="Bounding box"
                            width="24"
                            height="24"
                            fill="#D9D9D9"
                          />
                        </mask>
                        <g mask="url(#mask0_6_1855)">
                          <path
                            id="arrow_back_2"
                            d="M7.37302 12.75L13.0692 18.4461L12 19.5L4.5 12L12 4.5L13.0692 5.55383L7.37302 11.25H19.5V12.75H7.37302Z"
                            fill="#1C1B1F"
                          />
                        </g>
                      </g>
                    </svg>
                  </Fragment>
                ) : truckNomination.result?.nominationType === "Discharge" ? (
                  <Fragment>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="arrow_forward">
                        <mask
                          id="mask0_6_1843"
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="24"
                          height="24"
                        >
                          <rect
                            id="Bounding box"
                            width="24"
                            height="24"
                            fill="#D9D9D9"
                          />
                        </mask>
                        <g mask="url(#mask0_6_1843)">
                          <path
                            id="arrow_forward_2"
                            d="M16.6269 12.75H4.5V11.25H16.6269L10.9308 5.55383L12 4.5L19.5 12L12 19.5L10.9308 18.4461L16.6269 12.75Z"
                            fill="#1C1B1F"
                          />
                        </g>
                      </g>
                    </svg>
                  </Fragment>
                ) : (
                  <Fragment></Fragment>
                )}
              </Fragment>
              <div className={classes.headerRowTextPane}>
                <span className={classes.headerTitle}>
                  {toNominationNo(lineHandlingNo)}
                </span>
              </div>
              <AttachmentModal />
            </div>
          </div>
          <TruckNominationHeader {...props} />
        </Fragment>
      ) : (
        <NominationHeader />
      )}
      <div
        style={{ backgroundColor: "white", margin: "12px 8px", height: "100%" }}
      >
        <div
          className="ms-Grid-row"
          style={{
            padding: "12px 24px",
            fontWeight: "bold",
            borderBottom: "1px solid #E2E6E8",
            borderTop: "1px solid #E2E6E8",
            margin: 0,
            color: "#7C7777",
          }}
        >
          <div id="packet-scroll" dir="ltr">
            <div className="ms-Grid-col ms-md5" style={{ paddingLeft: 0 }}>
              <div
                className="d-flex"
                style={{
                  color: "var(--grey-800)",
                  lineHeight: "39px",
                  alignItems: "center",
                }}
              >
                <Checkbox
                  onChange={(e, value?: boolean) => handleSelectAll(value)}
                  styles={{
                    checkbox: {
                      width: "18px",
                      height: "18px",
                      marginTop: "8px",
                      marginRight: "19px",
                    },
                  }}
                />
                Select all
              </div>
            </div>
            <div className="ms-Grid-col ms-md7" style={{ padding: "0" }}>
              <div className={classes.flexEnd} style={{ gap: "8px" }}>
                <Dropdown
                  options={getOptions()}
                  styles={dropdownStyles}
                  onChange={(e, selectedOption) => {
                    if (selectedOption?.key === "0") {
                      setWorkPackets(
                        unfilteredWorkPackets.filter(
                          (v) => v.workPacketType === 3
                        )
                      );
                    } else if (selectedOption?.key === "All") {
                      setWorkPackets(unfilteredWorkPackets);
                    } else {
                      setWorkPackets(
                        unfilteredWorkPackets.filter(
                          (v) => v.nominationNo === selectedOption?.key
                        )
                      );
                    }
                  }}
                  onRenderOption={(option) => {
                    return (
                      <div>
                        <span style={{ fontWeight: "bold" }}>
                          {option!.text}
                        </span>
                        <br />
                        <span className={classes.detailsDiv}>
                          {option!.title}
                        </span>
                      </div>
                    );
                  }}
                />
                <div className={classes.flexEnd} style={{ gap: "8px" }}>
                  <button
                    className={classes.viewButton}
                    onClick={sendEmailModal}
                    disabled={selectedItems.length > 0 ? false : true}
                  >
                    <SofIcon iconname="Mail" />
                  </button>
                  <button
                    className={classes.viewButton}
                    onClick={download}
                    disabled={selectedItems.length > 0 ? false : true}
                  >
                    <SofIcon iconname="Download" />
                  </button>
                  <button
                    className={classes.viewButton}
                    onClick={printPreview}
                    disabled={selectedItems.length > 0 ? false : true}
                  >
                    <SofIcon iconname="Print" />
                  </button>
                </div>
                {((modality === "MARINE" &&
                  (props.isMarineDeliveryTruckOnly ||
                    props.isMarineProcessAdditionalServices)) ||
                  (modality === "TRUCK" &&
                    props.isTruckProcessAdditionalServices) ||
                  (modality === "RAIL" &&
                    props.isTruckProcessAdditionalServices)) &&
                  !readonly && (
                    <button
                      className={classes.addNew}
                      onClick={() =>
                        modality === "TRUCK"
                          ? history.push(
                              `/truck/${lineHandlingNo}/services/group/`
                            )
                          : modality === "RAIL"
                          ? history.push(
                              `/rail/${lineHandlingNo}/services/group/`
                            )
                          : history.push(
                              `/marine/${lineHandlingNo}/services/group/`
                            )
                      }
                    >
                      <FontIcon iconName="add" />
                      <span style={{ marginLeft: "8px" }}>Add New</span>
                    </button>
                  )}
              </div>
            </div>
          </div>
        </div>
        <div
          id="div-nomination-list"
          className={clsx(classes.packetList, "custom-scroll")}
        >
          <div id="packet-scroll" dir="ltr">
            {workPackets.map((packet: WorkPacketExt, i: number) => {
              return (
                <div
                  key={`wp-doc-${i}`}
                  className="ms-Grid"
                  dir="ltr"
                  style={{ backgroundColor: "white", padding: "0px" }}
                >
                  <div
                    className="ms-Grid-row"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "12px 24px",
                      borderBottom: "1px solid #E2E6E8",
                    }}
                  >
                    <div className="ms-Grid-col ms-md9">
                      <div className="d-flex" style={{ alignItems: "center" }}>
                        <Checkbox
                          className="me-3"
                          onChange={(e, value?: boolean) =>
                            handleCheckboxChange(packet, value)
                          }
                          checked={
                            selectedItems.find(
                              (item: any) => item.key === packet.key
                            )
                              ? true
                              : false
                          }
                          styles={{
                            checkbox: {
                              width: "18px",
                              height: "18px",
                              marginTop: "8px",
                            },
                          }}
                        />
                        <span
                          className="list-item-title"
                          style={{
                            color: "var(--grey-800)",
                            fontSize: 14,
                            fontWeight: 700,
                            marginLeft: "8px",
                          }}
                        >
                          {packet.displayName}
                        </span>
                      </div>
                    </div>
                    <div className="ms-Grid-col ms-md3">
                      <div className={classes.flexEnd}>
                        {/* <div style={{ display: "flex", alignItems: "center" }}>
                          <div
                            className={classes.dotIndicator}
                            style={{ background: colorEnum[0] }}
                          ></div>
                          <p
                            style={{
                              margin: 0,
                              marginRight: "20px",
                              display: "flex",
                              alignItems: "center"
                            }}
                          >
                            {getStatusByValue(packet.status)}
                          </p>
                        </div> */}
                        <div style={{ display: "flex", alignItems: "center" }}>
                          {getKeyByValue(
                            props.workPacketDocuments.result,
                            packet.id,
                            packet.nominationNo
                          ) ? (
                            <>
                              {getKeyByValue(
                                props.workPacketDocuments.result,
                                packet.id,
                                packet.nominationNo
                              )?.status === 2 ? (
                                <div
                                  className={classes.dotIndicator}
                                  style={{ background: "#4CAF50" }}
                                ></div>
                              ) : (
                                <div
                                  className={classes.dotIndicator}
                                  style={{ background: "#F0990D" }}
                                ></div>
                              )}
                            </>
                          ) : (
                            <div
                              className={classes.dotIndicator}
                              style={{ background: colorEnum[0] }}
                            ></div>
                          )}
                          <p
                            style={{
                              margin: 0,
                              marginRight: "20px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {getKeyByValue(
                              props.workPacketDocuments.result,
                              packet.id,
                              packet.nominationNo
                            ) ? (
                              <>
                                {getKeyByValue(
                                  props.workPacketDocuments.result,
                                  packet.id,
                                  packet.nominationNo
                                )?.status === 2 ? (
                                  <>Completed</>
                                ) : (
                                  <>Updated</>
                                )}
                              </>
                            ) : (
                              <>Pending</>
                            )}
                          </p>
                        </div>
                        {(modality === "MARINE" &&
                          props.isMarineProcessAdditionalServices) ||
                        (modality === "TRUCK" &&
                          props.isTruckProcessAdditionalServices) ||
                        (modality === "RAIL" &&
                          props.isTruckProcessAdditionalServices) ? (
                          <Fragment>
                            <Link
                              className={classes.viewButton}
                              to={packet.link}
                            >
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M8.33333 5V6.66667H4.16667V15.8333H13.3333V11.6667H15V16.6667C15 16.8877 14.9122 17.0996 14.7559 17.2559C14.5996 17.4122 14.3877 17.5 14.1667 17.5H3.33333C3.11232 17.5 2.90036 17.4122 2.74408 17.2559C2.5878 17.0996 2.5 16.8877 2.5 16.6667V5.83333C2.5 5.61232 2.5878 5.40036 2.74408 5.24408C2.90036 5.0878 3.11232 5 3.33333 5H8.33333ZM17.5 2.5V9.16667H15.8333V5.34417L9.33917 11.8392L8.16083 10.6608L14.6542 4.16667H10.8333V2.5H17.5Z"
                                  fill="#353B3B"
                                />
                              </svg>
                            </Link>
                          </Fragment>
                        ) : (
                          <Fragment>
                            {props.isMarineDeliveryTruckOnly &&
                              packet.group === "Delivery Truck" && (
                                <Link
                                  className={classes.viewButton}
                                  to={packet.link}
                                >
                                  <svg
                                    width="12"
                                    height="12"
                                    viewBox="0 0 12 12"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M2.5 1C2.10218 1 1.72064 1.15804 1.43934 1.43934C1.15804 1.72064 1 2.10218 1 2.5V9.5C1 9.89782 1.15804 10.2794 1.43934 10.5607C1.72064 10.842 2.10218 11 2.5 11H9.5C9.89782 11 10.2794 10.842 10.5607 10.5607C10.842 10.2794 11 9.89782 11 9.5V7.27C11 7.13739 11.0527 7.01021 11.1464 6.91645C11.2402 6.82268 11.3674 6.77 11.5 6.77C11.6326 6.77 11.7598 6.82268 11.8536 6.91645C11.9473 7.01021 12 7.13739 12 7.27V9.5C12 10.163 11.7366 10.7989 11.2678 11.2678C10.7989 11.7366 10.163 12 9.5 12H2.5C1.83696 12 1.20107 11.7366 0.732233 11.2678C0.263392 10.7989 0 10.163 0 9.5V2.5C0 1.83696 0.263392 1.20107 0.732233 0.732233C1.20107 0.263392 1.83696 0 2.5 0H4.73C4.86261 0 4.98979 0.0526785 5.08355 0.146447C5.17732 0.240215 5.23 0.367392 5.23 0.5C5.23 0.632608 5.17732 0.759785 5.08355 0.853553C4.98979 0.947321 4.86261 1 4.73 1H2.5ZM6.77 0.5C6.77 0.367392 6.82268 0.240215 6.91645 0.146447C7.01021 0.0526785 7.13739 0 7.27 0H11.5C11.6326 0 11.7598 0.0526785 11.8536 0.146447C11.9473 0.240215 12 0.367392 12 0.5V4.73C12 4.86261 11.9473 4.98979 11.8536 5.08355C11.7598 5.17732 11.6326 5.23 11.5 5.23C11.3674 5.23 11.2402 5.17732 11.1464 5.08355C11.0527 4.98979 11 4.86261 11 4.73V1.708L7.623 5.084C7.57688 5.13176 7.5217 5.16985 7.4607 5.19605C7.3997 5.22226 7.33409 5.23605 7.2677 5.23663C7.20131 5.2372 7.13547 5.22455 7.07402 5.19941C7.01258 5.17427 6.95675 5.13714 6.9098 5.0902C6.86286 5.04325 6.82573 4.98743 6.80059 4.92598C6.77545 4.86453 6.7628 4.79869 6.76337 4.7323C6.76395 4.66591 6.77774 4.6003 6.80395 4.5393C6.83015 4.4783 6.86825 4.42312 6.916 4.377L10.293 1H7.269C7.13639 1 7.00921 0.947321 6.91545 0.853553C6.82168 0.759785 6.769 0.632608 6.769 0.5H6.77Z"
                                      fill="black"
                                    />
                                  </svg>
                                </Link>
                              )}
                          </Fragment>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-md12">
                <Text
                  variant="small"
                  block
                  style={{ textAlign: "center", color: "#c4c4c4" }}
                >
                  - End of list -
                </Text>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        id="print-preview-modal"
        title="WorkPackets"
        className={classes.modalEmail}
        showModalHeader={false}
      >
        <div>
          <div className={classes.modalContainer}>
            <div className={classes.modalPdfPreviewContainer}>
              <iframe
                id="print-window"
                scrolling="no"
                src={`${pdfContent}#toolbar=0&zoom=100`}
                frameBorder={0}
                style={{ position: "relative", height: "100%", width: "100%" }}
              ></iframe>
            </div>
            <div className={classes.modalRightPanelContainer}>
              <div>
                <div className={classes.formHeader}>
                  <span className={classes.formHeaderTitle}>
                    Print Preview of{" "}
                    {modality === "TRUCK" ? "Services" : "Work Packets"}
                  </span>
                  <div style={{ flexGrow: 1 }}></div>
                  <div className={classes.toolbarSeparator}></div>
                  <button
                    id="btn-close"
                    type="button"
                    className={buttonIcon}
                    onClick={closePrintPreviewModal}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <path
                        d="M0.589143 0.715991L0.646143 0.645991C0.728999 0.563315 0.838234 0.512329 0.954817 0.501913C1.0714 0.491497 1.18794 0.522313 1.28414 0.588991L1.35414 0.645991L6.00014 5.29299L10.6461 0.645991C10.74 0.552104 10.8674 0.499359 11.0001 0.499359C11.1329 0.499359 11.2603 0.552104 11.3541 0.645991C11.448 0.739877 11.5008 0.867215 11.5008 0.999991C11.5008 1.13277 11.448 1.2601 11.3541 1.35399L6.70714 5.99999L11.3541 10.646C11.4368 10.7288 11.4878 10.8381 11.4982 10.9547C11.5086 11.0712 11.4778 11.1878 11.4111 11.284L11.3541 11.354C11.2713 11.4367 11.1621 11.4877 11.0455 11.4981C10.9289 11.5085 10.8123 11.4777 10.7161 11.411L10.6461 11.354L6.00014 6.70699L1.35414 11.354C1.26026 11.4479 1.13292 11.5006 1.00014 11.5006C0.867368 11.5006 0.74003 11.4479 0.646143 11.354C0.552257 11.2601 0.499512 11.1328 0.499512 11C0.499512 10.8672 0.552257 10.7399 0.646143 10.646L5.29314 5.99999L0.646143 1.35399C0.563468 1.27114 0.512481 1.1619 0.502066 1.04532C0.49165 0.928733 0.522465 0.81219 0.589143 0.715991Z"
                        fill="#4C4C4C"
                      />
                    </svg>
                  </button>
                </div>
                <div className={classes.modalSelectedItemWrapper}>
                  {selectedItems.map((a: { displayName: string }) => {
                    return (
                      <div className={classes.modalSelectedItem}>
                        <div style={{ display: "flex" }}>
                          <div
                            style={{
                              position: "relative",
                              top: "-6px",
                              padding: 5,
                            }}
                          >
                            <svg
                              width="24"
                              height="24"
                              fill="none"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 1.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17Zm-1.25 9.94 4.47-4.47a.75.75 0 0 1 1.133.976l-.073.084-5 5a.75.75 0 0 1-.976.073l-.084-.073-2.5-2.5a.75.75 0 0 1 .976-1.133l.084.073 1.97 1.97 4.47-4.47-4.47 4.47Z"
                                fill="#27AF60"
                              />
                            </svg>
                          </div>
                          <div>{a.displayName}</div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className={classes.formFooter}>
                <button
                  type="submit"
                  className={classes.sendButton}
                  onClick={printDoc}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5em",
                    }}
                  >
                    <div style={{ position: "relative", top: "-1px" }}>
                      <svg
                        width="24"
                        height="24"
                        fill="none"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.752 3a2.25 2.25 0 0 1 2.25 2.25v.753h.75a3.254 3.254 0 0 1 3.252 3.25l.003 5.997a2.249 2.249 0 0 1-2.248 2.25H18v1.25A2.25 2.25 0 0 1 15.75 21h-7.5A2.25 2.25 0 0 1 6 18.75V17.5H4.25A2.25 2.25 0 0 1 2 15.25V9.254a3.25 3.25 0 0 1 3.25-3.25l.749-.001L6 5.25A2.25 2.25 0 0 1 8.25 3h7.502Zm-.002 10.5h-7.5a.75.75 0 0 0-.75.75v4.5c0 .414.336.75.75.75h7.5a.75.75 0 0 0 .75-.75v-4.5a.75.75 0 0 0-.75-.75Zm3.002-5.996H5.25a1.75 1.75 0 0 0-1.75 1.75v5.996c0 .414.336.75.75.75H6v-1.75A2.25 2.25 0 0 1 8.25 12h7.5A2.25 2.25 0 0 1 18 14.25V16h1.783a.749.749 0 0 0 .724-.749l-.003-5.997a1.754 1.754 0 0 0-1.752-1.75Zm-3-3.004H8.25a.75.75 0 0 0-.75.75l-.001.753h9.003V5.25a.75.75 0 0 0-.75-.75Z"
                          fill="#fff"
                        />
                      </svg>
                    </div>
                    <div>Print</div>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        id="sendemail-modal"
        title="Send Work Packets"
        className={classes.modalEmail}
        showModalHeader={false}
      >
        <Email
          id="email"
          pdfSrc={pdfContent}
          emailStatus={emailStatus}
          emailAddresses={emailAddresses}
          setEmailAddresses={setEmailAddresses}
          closeEmailModal={closeEmailModal}
          sendEmail={sendEmail}
          selectedWorkPackets={selectedItems}
          isLoaded={isLoaded}
        ></Email>
      </Modal>
    </div>
  );
};
export default connect(
  (state: State) => ({
    ...state.workPacket,
    ...state.activityLogs,
    ...state.lineHandling,
    ...state.general,
    ...state.sofView,
    ...state.truckNomination,
  }),
  {
    ...WorkPacketStore.actionCreators,
    ...GeneralStore.actionCreators,
    ...LineHandlingStore.actionCreators,
    ...SofViewStore.actionCreators,
    ...TruckNominationStore.actionCreators,
  }
)(ServicesList as any);
